/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Himank Jain",
  title: "Hello, Himank here",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Distributed system applications with Java / Springboot / Kafka / Spark / Javascript / Angular and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1aEMD70DrAlOjUORmcEzGmEKvIzXaCJzr/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/himank28",
  linkedin: "https://www.linkedin.com/in/himank-jain-04hj/",
  gmail: "himankjain28@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/himank.jain.92/",
  medium: "https://medium.com/@jain.mayank753",
  stackoverflow: "https://stackoverflow.com/users/21361398/himank-jain",
  instagram:"https://www.instagram.com/himankjain28/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE TECH AND TACKLE REAL WORLD PROBLEMS WITH IT",
  skills: [
    emoji(
      "⚡  Build highly scalable and robust backend systems."
    ),
    emoji("⚡ Craft intuitive and responsive user interfaces using JavaScript and Angular, enhancing user experience and driving engagement on web applications."),
    emoji(
      "⚡ Integration of third party services such as Kafka / AWS."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },

    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "St John College of Engineering and Management",
      logo: require("./assets/images/JohnLogo.jpeg"),
      subHeader: "Bachelor of Electronics and Communication",
      duration: "August 2014 - April 2018",
      desc: "Ranked top 10% in the program.",
      descBullets: [
        "Took courses about Software Engineering, Web Security, Operating Systems, ...",
        "Organised seminars and technical events."
      ]
    },
    {
      schoolName: "VIVA College",
      logo: require("./assets/images/VivaLogo.png"),
      subHeader: "HSC Degree",
      duration: "August 2012 - April 2014",
      desc: "Secured 20% among the batch.",
      descBullets: ["Took interest in curricular activities and got smooth in public speaking, organizing events ..."]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Problem Solving",
      progressPercentage: "80%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "60%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Distributed systems",
      progressPercentage: "40%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Currencies Direct",
      companylogo: require("./assets/images/currencies_direct_logo.jpeg"),
      date: "August 2023 – Present",
      desc: "Design and create Robust scalable event based microservices for international payment compliance checks",
      descBullets: [
      "Building web and middleware applications as per the requirement with appropriate technology as suits the application.",
      "Involved in the complete SDLC process from requirement analysis to delivery on production , including support.",
      "Providing Client-Centric solutions for enhancement of application and increase in its usage.",
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Aynara Technologies",
      companylogo: require("./assets/images/AynaraLogo.jpeg"),
      date: "July 2022 – July 2023",
      desc: "Work on Microservice application and migrate to Springboot and Angular tech stack.",
      descBullets:[
      "Handle Estimation to delivery,each step as per the standard process defined by the company.",
      "Deploying application in all environments and fixing bugs.",
      "Handling production issues and QA bugs of application.",
      "Documentation for solutions and approaches implemented in application."
      ]
    },
    {
      role: "Software Engineer",
      company: "Neebal Technologies",
      companylogo: require("./assets/images/NeebalLogo.png"),
      date: "Dec 2018 – June 2022",
      desc: "Started of as Trainee and moved up to be a Team Lead for Banking client.",
      descBullets: [
        "Worked as Team lead for a 7 member team , handling banking projects with Java, Springboot and varied technologies for appropriate solutions.",
        "In depth understanding of Spark Architecture including Spark Core, SparkSQL, DataFrames,Spark Streaming, Spark Mlib.",
        "Experience in various big data application phases like data ingestion, data analytics, data visualization.",
        "Handle Estimation to delivery,each step as per the standard process defined by the company."
      ]

    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME COMPANIES THAT I HELPED TO CREATE THEIR TECH PROJECTS",
  projects: [
    {
      image: require("./assets/images/AmeriSave-Logo.jpg"),
      projectName: "Amerisave Rules Engine",
      projectDesc: "Complete Digital mortgage processing rules engine to process loans seamlessly.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.amerisave.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/YesBankLogo.png"),
      projectName: "Yes Bank ",
      projectDesc: "Corporate web portal and payment processing service.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.yesbank.in/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    
    {
      title: "Mulesoft Integration Developer",
      subtitle: "Completed Certifcation for Mule-4 for integration with flows on Mulesoft",
      image: require("./assets/images/MulesoftLogo.png"),
      imageAlt: "Mulesoft Logo",
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/14TmUSaRSCQ892rdaQqePavcOQG3sh2Z5/view?usp=drive_link"}
      ]
    },
    {
        title: "OCJP Training Certificate",
        subtitle: "Completed Training of Java from CMPInfotech",
        image: require("./assets/images/Java-Logo.png"),
        imageAlt: "Java Logo",
        footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B57FQ0pzo3frWHdpbnBac3N5aFU/view?usp=drive_link&resourcekey=0-Iu_4PdpwpCcXIQoo4rD4FQ"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7385064640",
  email_address: "himankjain28@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
